export default {
  clickedButton_addSpraying: 'clickedButton_PlanningDiseases-addSpraying',
  clickedButton_createdSpraying:
    'clickedButton_planningDiseases-createdSpraying',
}
